import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import EStores from '../../enums/EStores';
import IReducedAgency from "../../interfaces/reduced/IReducedAgency";
import {SetSelectedCompany} from "../../utils/selectCompany";

export interface ICompanies {
  all: IReducedAgency[];
  selected: any | null;
}

const initialState: ICompanies = {
  all: [],
  selected: null,
};

const slice = createSlice({
  name: EStores.COMPANIES,
  initialState,
  reducers: {
    setAll(state, action: PayloadAction<IReducedAgency[]>) {
      state.all = action.payload;
      return state;
    },
    selectCompany(state, action: PayloadAction<IReducedAgency>) {
      state.selected = action.payload;

      SetSelectedCompany(action.payload.id);

      return state;
    }
  },
});

export const {
  setAll,
  selectCompany,
} = slice.actions;

export default slice.reducer;
